import { FilterExpression, like } from '@infuse/api/common';

export const createSearchFilter = (searchQuery: string, fields: string[]): FilterExpression => {
  if (!searchQuery || fields.length === 0) {
    return new FilterExpression();
  }

  const parts = searchQuery
    .toLowerCase()
    .split(' ')
    .filter((part: string): boolean => !!part)
    .map((part: string): string => `%${part}%`);

  if (parts.length === 0) {
    return new FilterExpression();
  }

  const expressions: FilterExpression[] = [];
  for (const part of parts) {
    for (const field of fields) {
      expressions.push(like(`lower(${field})`, part));
    }
  }

  return expressions.reduce((acc, expr) => acc.or(expr));
};
